/**
 * Where the chosen theme is remembered.
 *
 * Shared deliberately. The value is read twice: by next-themes once React is running, and by
 * the inline script in index.html that runs before the first paint. If those two ever disagree
 * the page renders light, then flips to dark a moment later — the flash the script exists to
 * prevent — and nothing would fail except the look of it. There is a test asserting index.html
 * still contains this exact string.
 */
export const THEME_STORAGE_KEY = "vb-theme";
